module.exports = __webpack_public_path__ + "static/media/check-inactive.2c04622c.svg";